module.exports = __webpack_public_path__ + "Unionka.jpg?b96ff796927cd46f98459ebadab7f896";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Unionka.jpg
// module id = 230
// module chunks = 0